import { isBloggerBusiness } from '../../../utils/accessService';
import { buildImageSource, buildImageSourceSet } from '../../../utils/buildImageSource';
import { getDomainFromUrl } from '../../../utils/getDomainFromUrl/getDomainFromUrl';
import { IconProduct } from '../../icon/IconProduct';
import { Flex } from '../../layout/Flex';
import { Image } from '../../media/Image';
import { ProductUnavailableLabel } from '../../posts/ProductUnavailableLabel/ProductUnavailableLabel';
import { Typography } from '../../typography/Typography';
import { ImageWrapper } from '../ProductSnippet/styles';
import { Wrapper } from './styles';
import { UnavailableProductSnippetProps } from './typings';

export const UnavailableProductSnippet: React.FC<UnavailableProductSnippetProps> = ({
    product,
    businessType,
    isMultipleProducts,
    ...other
}) => {
    const domain = isBloggerBusiness(businessType)
        ? getDomainFromUrl(product.originalUrl)
        : undefined;

    if (!product) {
        return null;
    }

    const media = product.content[0]?.media;

    return (
        <Wrapper {...other} p={isMultipleProducts ? 0.5 : 1} pr={1}>
            {media ? (
                <ImageWrapper opacity={0.5} isMultipleProducts={isMultipleProducts}>
                    <Image
                        objectFit="cover"
                        width="100%"
                        height="100%"
                        src={buildImageSource(media)}
                        srcSet={buildImageSourceSet(media)}
                    />
                </ImageWrapper>
            ) : (
                <ImageWrapper isMultipleProducts={isMultipleProducts}>
                    <IconProduct
                        size={36}
                        color="var(--control-secondary-background)"
                        margin="auto"
                    />
                </ImageWrapper>
            )}
            <Flex width="100%">
                {product.title ? (
                    <Typography variant="body2" loose lines={2} color="secondary" pb={0.25}>
                        {product.title}
                    </Typography>
                ) : null}
                <ProductUnavailableLabel widthHint />
                {domain ? (
                    <Typography variant="caption" color="var(--color-secondary)" mt={0.25}>
                        {domain}
                    </Typography>
                ) : null}
            </Flex>
        </Wrapper>
    );
};
